// Older versions typed a linked customer's name into the message as
// "[Name]". The customer card shows it now, so the token is hidden.
export const withoutCustomerToken = (text, customer) => {
	if (!text || !customer?.name) {
		return text;
	}

	return text.replace(`[${customer.name}]`, '').trim();
};
